<template>
  <b-form-group
    label="Teklif Durumu"
    label-for="id_offer_statuses"
  >
    <validation-provider
      #default="{ errors }"
      name="Teklif Durumu"
      rules="required"
    >
      <v-select
        id="id_offer_statuses"
        v-model="dataItem.id_offer_statuses"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
        :disabled="isNew"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'OfferStatus',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['offers/dataItem']
    },
    dataList() {
      return this.$store.getters['offerStatuses/dataList']
    },
  },
  created() {
    this.getData()
    localize('tr')
  },
  mounted() {
    this.setDefaultStatus()
  },
  methods: {
    setDefaultStatus() {
      if (this.isNew) {
        this.dataItem.id_offer_statuses = '1'
      }
    },
    getData() {
      this.$store.dispatch('offerStatuses/getDataList', {
        select: [
          'offer_statuses.id AS id',
          'offer_statuses.title AS title',
        ],
      })
    },
  },
}
</script>
